export const setSelectedTopicForQuestion = (state, payload) => {
    return {
      ...state,
      [payload.questionId]:{
        ...state[payload.questionId],
        selectedTopic : payload.topic
      },
    };
  };